module.exports = __webpack_public_path__ + "static/media/си.1054a811.mp3";